import { Box, Button, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { Sticky } from './utils'

interface Props {
  onClickEdit: () => void
  onClickDelete: () => void
}

const SavedShiftOptions = ({ onClickEdit, onClickDelete }: Props) => {
  const sticky: Sticky = {
    position: 'right',
  }

  return (
    <Table.Cell sticky={sticky}>
      <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
        <Popover type="list">
          <Popover.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </Popover.Trigger>
          <Popover.Content side="bottom" align="center">
            <Popover.TouchableOption
              onClick={onClickEdit}
              title={i18n.t('shift_management.saved_shifts.actions.edit.title')}
            />
            <Popover.TouchableOption
              danger
              onClick={onClickDelete}
              title={i18n.t('shift_management.saved_shifts.actions.delete.title')}
            />
          </Popover.Content>
        </Popover>
      </Box>
    </Table.Cell>
  )
}

export default observer(SavedShiftOptions)
